module.exports = __webpack_public_path__ + "406c5b6ee58bbc4c9607567ad85a6bad.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/walking.jpg
// module id = 643
// module chunks = 0